(() => {
    const SELECTORS = {
        overlay: "[data-drawer-overlay]",
        close: "[data-drawer-close]",
        content: "[data-drawer-content]",
        footer: "[data-drawer-footer]",
        item: "[data-line]",
        qtyMinus: "[data-qty-minus]",
        qtyPlus: "[data-qty-plus]",
        qtyInput: "[data-qty-input]",
        remove: "[data-remove]",
        urgency: "[data-urgency]",
        urgencyFill: "[data-urgency-fill]",
        savingsWrap: "[data-cart-savings]",
        savingsAmount: "[data-savings-amount]",
    };

    const GIFT_WRAP_VARIANT_ID = 52550245974330;

    function isOnlyGiftWrap(cart) {
        return (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        );
    }

    function calculateCartSavings(cart) {
        if (!cart || !cart.items) return 0;
        return (
            cart.items.reduce((sum, item) => {
                return sum + Math.max(0, item.original_line_price - item.final_line_price);
            }, 0) / 100
        );
    }

    function toggleEmptyState(container, cart) {
        const nonEmpty = container.querySelector('[data-cart-non-empty]');
        const wearWithIt = container.querySelector('[data-wear-with-it]');
        const isEmpty = cart.item_count === 0 || isOnlyGiftWrap(cart);
        if (nonEmpty) nonEmpty.style.display = isEmpty ? 'none' : '';
        if (wearWithIt) wearWithIt.style.display = isEmpty ? 'none' : '';
    }

    function updateCartCountBubble(cart) {
        if (!cart) return;
        const count = cart.item_count || 0;
        const update = () => {
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            const navCounts = document.querySelectorAll('[data-cart-count]');
            if (!bubbles.length && !navCounts.length) return false;
            bubbles.forEach((bubble) => {
                const visible = bubble.querySelector('span[aria-hidden]');
                const hidden = bubble.querySelector('.visually-hidden');
                if (visible) visible.textContent = count;
                if (hidden) hidden.textContent = `${count} items`;
                bubble.classList.toggle('hidden', count === 0);
            });
            navCounts.forEach((el) => {
                el.textContent = count;
                el.classList.toggle('show', count > 0);
            });
            return true;
        };
        if (!update()) setTimeout(update, 120);
    }

    function syncGiftWrapCheckboxFromCart(cart, container) {
        const checkbox = container.querySelector('[data-gift-wrap-checkbox]');
        const wrapper = checkbox?.closest('[data-gift-wrap-wrapper]') || checkbox?.closest('.kymee-giftwrap-pill');
        if (!checkbox) return;
        const hasGiftWrap = cart.items.some(item => item.variant_id === GIFT_WRAP_VARIANT_ID);
        wrapper?.classList.toggle('is-active', hasGiftWrap);
        checkbox.checked = hasGiftWrap;
        checkbox.setAttribute('aria-checked', hasGiftWrap ? 'true' : 'false');
    }

    async function removeGiftWrapIfOnlyItem(cart) {
        if (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        ) {
            await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: cart.items[0].key, quantity: 0 }),
            });
            return true;
        }
        return false;
    }

    /* ── Recently Viewed ─────────────────────────────────────── */

    async function renderRecentlyViewed(container) {
        const el = container.querySelector("[data-recently-viewed]");
        if (!el) return;
        const list = JSON.parse(localStorage.getItem("kymee-recently-viewed") || "[]");
        if (!list.length) {
            el.innerHTML = '<p class="kymee-accordion__empty-msg">No recently viewed products</p>';
            return;
        }
        el.innerHTML = `<div class="kymee-wishlist-loading"><span class="kymee-spinner kymee-spinner--lg"></span></div>`;
        const SECTION = "kymee-drawer-rv";
        const results = await Promise.all(
            list.slice(0, 6).map(async (item) => {
                const handle = (item.url || "").split("/products/")[1]?.split("?")[0]?.split("#")[0];
                if (!handle) return { item, cardHtml: null };
                try {
                    const res = await fetch(`/products/${handle}?sections=${SECTION}`);
                    if (!res.ok) throw new Error();
                    const data = await res.json();
                    return { item, cardHtml: data[SECTION] || null };
                } catch { return { item, cardHtml: null }; }
            })
        );
        const cards = results.map(({ item, cardHtml }) => {
            const inner = cardHtml ?? `
                <div class="card-wrapper product-card-wrapper">
                    <a href="${item.url || "#"}" style="display:block">
                        <img src="${item.img || ""}" alt="${item.title || ""}" loading="lazy" style="width:100%;border-radius:8px">
                        <div style="padding:6px 4px;font-size:12px">${item.title || ""}</div>
                        <div style="padding:0 4px 6px;font-size:12px;color:#666">${item.price || ""}</div>
                    </a>
                </div>`;
            return `<li class="kymee-drawer-wl-card">${inner}</li>`;
        });
        el.innerHTML = `<ul class="kymee-wear-with-it_ul kymee-rv-list">${cards.join("")}</ul>`;
        // Products async load hone ke baad scroll initialize karo
        // (pehle initDragScrolls tab run hota tha jab .kymee-rv-list exist hi nahi karta tha)
        setTimeout(initDragScrolls, 50);
    }

    function renderRecentlyViewedIfOpen(container) {
        const el = container.querySelector("[data-recently-viewed]");
        const accordion = el?.closest("[data-accordion]");
        if (accordion?.classList.contains("is-open")) renderRecentlyViewed(container);
    }

    /* ── Wishlist Tab ────────────────────────────────────────── */

    async function renderWishlistTab(container) {
        const el = container.querySelector("[data-wishlist-content]");
        if (!el) return;
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        if (!list.length) {
            el.innerHTML = `<div class="kymee-wishlist-empty">
                <p>Your wishlist is empty</p>
                <a href="/collections/best-seller" class="kymee-btn kymee-btn--ghost" style="margin-top:12px;width:auto;padding:8px 20px;">Explore Products</a>
            </div>`;
            return;
        }
        el.innerHTML = `<div class="kymee-wishlist-loading"><span class="kymee-spinner kymee-spinner--lg"></span></div>`;
        const SECTION = "kymee-drawer-wishlist";
        const results = await Promise.all(list.map(async (item) => {
            const handle = (item.productUrl || "").split("/products/")[1]?.split("?")[0]?.split("#")[0];
            if (!handle) return { item, cardHtml: null };
            try {
                const res = await fetch(`/products/${handle}?sections=${SECTION}`);
                if (!res.ok) throw new Error();
                const data = await res.json();
                return { item, cardHtml: data[SECTION] || null };
            } catch { return { item, cardHtml: null }; }
        }));
        const cards = results.map(({ item, cardHtml }) => {
            const inner = cardHtml ?? `
                <div class="card-wrapper product-card-wrapper">
                    <div class="kymee-drawer-wl-fallback">
                        <a href="${item.productUrl || "#"}">
                            <img src="${item.productImg || ""}" alt="${item.productTitle || ""}" loading="lazy">
                        </a>
                        <div class="kymee-drawer-wl-fallback__info">
                            <a href="${item.productUrl || "#"}">${item.productTitle || ""}</a>
                            <span>${item.productPrice || ""}</span>
                        </div>
                    </div>
                </div>`;
            return `<div class="kymee-drawer-wl-card">${inner}</div>`;
        });
        el.innerHTML = `<div class="kymee-wishlist-grid">${cards.join("")}</div>`;
    }

    /* ── Confetti ────────────────────────────────────────────── */

    let kymeeConfettiRunning = false;
    let kymeeConfettiLastFired = 0;
    const CONFETTI_COOLDOWN_MS = 3000;

    function fireCanvasConfetti() {
        const now = Date.now();
        if (kymeeConfettiRunning || (now - kymeeConfettiLastFired) < CONFETTI_COOLDOWN_MS) return;
        kymeeConfettiRunning = true;
        kymeeConfettiLastFired = now;

        const canvas = document.getElementById("confetti");
        if (!canvas) { kymeeConfettiRunning = false; return; }

        const ctx = canvas.getContext("2d");
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        const colors = [
            "#FFD700", "#D4AF37", "#E8C27D", "#F5E6C8", "#C9A24D", "#B89B5E", "#FFECB3",
            "#6A0DAD", "#1F3C88", "#0F4C5C", "#006D5B", "#8B0000",
            "#FF6F91", "#FF9671", "#FFC75F", "#F9F871", "#CDB4DB",
            "#00B4D8", "#90DBF4", "#F15BB5", "#9B5DE5", "#4D96FF",
        ];

        const confettis = Array.from({ length: 180 }, () => ({
            x: Math.random() * canvas.width, y: -20,
            size: Math.random() * 5 + 4,
            color: colors[Math.floor(Math.random() * colors.length)],
            speedX: Math.random() * 3 - 1.5,
            speedY: Math.random() * 5 + 2.5,
            rotation: Math.random() * 360,
        }));

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let i = confettis.length - 1; i >= 0; i--) {
                const c = confettis[i];
                c.x += c.speedX; c.y += c.speedY; c.rotation += c.speedX;
                ctx.save();
                ctx.translate(c.x, c.y);
                ctx.rotate((c.rotation * Math.PI) / 180);
                ctx.fillStyle = c.color;
                ctx.fillRect(-c.size / 2, -c.size / 2, c.size, c.size);
                ctx.restore();
                if (c.y > canvas.height + 20) confettis.splice(i, 1);
            }
            if (confettis.length > 0) requestAnimationFrame(animate);
            else { ctx.clearRect(0, 0, canvas.width, canvas.height); kymeeConfettiRunning = false; }
        }
        animate();
    }

    /* ── Urgency Bar ─────────────────────────────────────────── */

    const Urgency = {
        rafId: null,

        stop() {
            if (this.rafId) cancelAnimationFrame(this.rafId);
            this.rafId = null;
        },

        getPercent(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return 0;
            const inline = parseFloat(fill.style.width);
            if (!Number.isNaN(inline)) return inline;
            const bar = fill.parentElement;
            if (!bar) return 0;
            const barW = bar.getBoundingClientRect().width || 1;
            const fillW = fill.getBoundingClientRect().width || 0;
            return Math.max(0, Math.min(100, (fillW / barW) * 100));
        },

        // Bar fill based on eligible item count (step from liquid) — Buy 1 = 10% (50%), Buy 2 = 20% (100%)
        getTarget(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return 0;
            const step = parseInt(wrap.dataset.step, 10) || 0;
            if (step >= 2) return 100;
            if (step >= 1) return 50;
            return 0;
        },

        paintDots(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return;
            const step = parseInt(wrap.dataset.step, 10) || 0;
            wrap.querySelectorAll(".dot").forEach((dot, i) => {
                let active;
                if (i === 0) active = step >= 1;
                else if (i === 1) active = step >= 1; // center dot at 50% position — activates with first item
                else active = step >= 2;              // fire dot — activates when 20% off unlocked
                dot.classList.toggle("active", active);
            });
        },

        animate(fill, from, to, duration = 420) {
            this.stop();
            const start = performance.now();
            const frame = (now) => {
                const t = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - t, 3);
                const value = from + (to - from) * eased;
                fill.style.width = value.toFixed(2) + "%";
                if (t < 1) this.rafId = requestAnimationFrame(frame);
            };
            this.rafId = requestAnimationFrame(frame);
        },

        render(container, fromOverride = null) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return;

            const target = this.getTarget(container);
            this.paintDots(container);

            const from = typeof fromOverride === "number"
                ? fromOverride
                : this.getPercent(container);

            // Fire GTM/confetti every time Shopify applies MORE discount than before —
            // whether that's from "Add to cart" or bumping the qty stepper inside the drawer.
            const discountedCount = parseInt(wrap.dataset.discountedCount, 10) || 0;
            const prev = this._prevDiscountedCount || 0;
            const step = parseInt(wrap.dataset.step, 10) || 0;

            if (discountedCount > prev) {
                document.dispatchEvent(
                    new CustomEvent("kymee:discount:urgency", {
                        detail: { step, percent: target },
                    })
                );
            }

            this._prevDiscountedCount = discountedCount;

            if (Math.abs(from - target) > 0.5) {
                this.animate(fill, from, target);
            } else {
                fill.style.width = target + "%";
            }
        },
    };

    /* ── Remove Modal ────────────────────────────────────────── */

    const KymeeRemoveModal = (() => {
        let drawerRef = null;
        let pendingLine = null;

        function getModal() { return document.getElementById("kymee-remove-modal"); }
        function getWishlistBtn(modal) { return modal?.querySelector(".wishlist_button"); }

        function fillWishlist(row) {
            const modal = getModal();
            const wishlistBtn = getWishlistBtn(modal);
            if (!wishlistBtn || !row) return;
            wishlistBtn.dataset.productId = row.dataset.productId || "";
            wishlistBtn.dataset.productTitle = row.dataset.productTitle || "";
            wishlistBtn.dataset.productImg = row.dataset.productImg || "";
            wishlistBtn.dataset.productPrice = row.dataset.productPrice || "";
            wishlistBtn.dataset.productUrl = row.dataset.productUrl || "";
            wishlistBtn.dataset.productVariantId = row.dataset.productVariantId || "";
            wishlistBtn.classList.remove("active");
            const imgEl = modal.querySelector("[data-product-remove-img]");
            if (imgEl && row.dataset.productImg) {
                imgEl.src = row.dataset.productImg;
                imgEl.alt = row.dataset.productTitle || "";
            }
        }

        function open({ drawer, line, row }) {
            const modal = getModal();
            if (!modal || pendingLine !== null) return;
            drawerRef = drawer; pendingLine = line;
            fillWishlist(row);
            modal.hidden = false;
        }

        function close() {
            const modal = getModal();
            if (!modal) return;
            modal.hidden = true; drawerRef = null; pendingLine = null;
        }

        document.addEventListener("click", (e) => {
            const modal = getModal();
            if (!modal || modal.hidden) return;
            const wishlistBtn = getWishlistBtn(modal);
            if (
                e.target.classList.contains("kymee-remove-modal__overlay") ||
                e.target.closest(".kymee-remove-modal__close")
            ) { close(); return; }
            if (e.target.closest("[data-remove-confirm]")) {
                drawerRef?.changeLine(pendingLine, 0); close(); return;
            }
            if (wishlistBtn?.contains(e.target)) {
                e.preventDefault(); e.stopPropagation();
                let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                const data = {
                    productId: wishlistBtn.dataset.productId,
                    productTitle: wishlistBtn.dataset.productTitle,
                    productImg: wishlistBtn.dataset.productImg,
                    productPrice: wishlistBtn.dataset.productPrice,
                    productUrl: wishlistBtn.dataset.productUrl,
                    productVariant: wishlistBtn.dataset.productVariantId,
                };
                if (!list.some((i) => i.productVariant === data.productVariant)) {
                    list.push(data);
                    localStorage.setItem("wishlist", JSON.stringify(list));
                    document.dispatchEvent(new CustomEvent("wishlist:updated"));
                }
                drawerRef?.changeLine(pendingLine, 0); close();
            }
        });

        return { open };
    })();

    /* ── KymeeCartDrawer Custom Element ──────────────────────── */

    class KymeeCartDrawer extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false;
            this.isRendering = false;
            this.pendingOpen = false;
            this._pendingRefresh = null;
            this.onOverlay = () => this.close();
            this.onClose = () => this.close();
            this.onKey = (e) => { if (e.key === "Escape" && this.isOpen) this.close(); };
            this.onClick = this.onClick.bind(this);
            this.onChange = this.onChange.bind(this);
        }

        connectedCallback() {
            this.overlayEl = this.querySelector(SELECTORS.overlay);
            this.closeEl = this.querySelector(SELECTORS.close);
            this.contentEl = this.querySelector(SELECTORS.content);
            this.footerEl = this.querySelector(SELECTORS.footer);

            this.overlayEl?.addEventListener("click", this.onOverlay);
            this.closeEl?.addEventListener("click", this.onClose);
            document.addEventListener("keydown", this.onKey);

            document.addEventListener("kymee:cart:added", () => {
                this.switchTab("bag");
                this.open();
                this.refresh({ openIfClosed: false });
            });

            this.addEventListener("click", this.onClick);
            this.addEventListener("change", this.onChange);

            this.querySelectorAll("[data-tab]").forEach((btn) =>
                btn.addEventListener("click", () => this.switchTab(btn.dataset.tab))
            );

            document.querySelector("#cart-icon-bubble")?.addEventListener("click", (e) => {
                e.preventDefault();
                this.switchTab("bag");
                this.open();
            });

            this.onNavCartClick = (e) => {
                if (!e.target.closest("button[data-nav='cart']")) return;
                e.preventDefault();
                this.switchTab("bag");
                this.open();
            };
            document.addEventListener("click", this.onNavCartClick);

            renderRecentlyViewedIfOpen(this);
            setTimeout(initDragScrolls, 50);
        }

        disconnectedCallback() {
            this.overlayEl?.removeEventListener("click", this.onOverlay);
            this.closeEl?.removeEventListener("click", this.onClose);
            document.removeEventListener("keydown", this.onKey);
            document.removeEventListener("click", this.onNavCartClick);
            this.removeEventListener("click", this.onClick);
            this.removeEventListener("change", this.onChange);
        }

        switchTab(tabName) {
            this.querySelectorAll("[data-tab]").forEach((btn) => {
                btn.classList.toggle("is-active", btn.dataset.tab === tabName);
                btn.setAttribute("aria-selected", btn.dataset.tab === tabName ? "true" : "false");
            });
            this.querySelectorAll("[data-tab-panel]").forEach((panel) =>
                panel.classList.toggle("is-hidden", panel.dataset.tabPanel !== tabName)
            );
            if (tabName === "wishlist") renderWishlistTab(this);
        }

        open() {
            if (this.isRendering) this.pendingOpen = true;
            if (this.isOpen) return;
            this.isOpen = true;
            this.classList.add("is-open");
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
            document.body.classList.add("kymee-drawer-open");
            requestAnimationFrame(() => {
                Urgency.render(this);
                renderRecentlyViewedIfOpen(this);
            });
        }

        close() {
            if (!this.isOpen) return;
            this.isOpen = false;
            this.classList.remove("is-open");
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
            document.body.classList.remove("kymee-drawer-open");
        }

        setLoading(state) { this.classList.toggle("is-loading", state); }

        async fetchCart() {
            const res = await fetch("/cart.js", { credentials: "same-origin" });
            return res.json();
        }

        async renderFromSection() {
            const res = await fetch("/?section_id=kymee-cart-drawer");
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            const fresh = doc.querySelector("kymee-cart-drawer");
            if (!fresh) return;

            this.contentEl.innerHTML = fresh.querySelector(SELECTORS.content)?.innerHTML || "";
            this.footerEl.innerHTML = fresh.querySelector(SELECTORS.footer)?.innerHTML || "";

            const newDesktopWear = fresh.querySelector(".kymee-wear-with-it-desktop__content");
            const oldDesktopWear = this.querySelector(".kymee-wear-with-it-desktop__content");
            if (newDesktopWear && oldDesktopWear) oldDesktopWear.innerHTML = newDesktopWear.innerHTML;

            const newUrgency = fresh.querySelector(SELECTORS.urgency);
            const oldUrgency = this.querySelector(SELECTORS.urgency);
            if (newUrgency && oldUrgency) oldUrgency.outerHTML = newUrgency.outerHTML;
        }

        async refresh({ openIfClosed, cartData = null }) {
            if (this.isRendering) { this._pendingRefresh = { openIfClosed, cartData }; return; }
            this.isRendering = true;

            const prevPercent = Urgency.getPercent(this);

            try {
                this.setLoading(true);

                const cartPromise = cartData ? Promise.resolve(cartData) : this.fetchCart();
                const sectionPromise = this.renderFromSection();
                const cart = await cartPromise;

                if (await removeGiftWrapIfOnlyItem(cart)) {
                    const freshCart = await this.fetchCart();
                    await this.renderFromSection();
                    updateCartCountBubble(freshCart);
                    toggleEmptyState(this, freshCart);
                    syncGiftWrapCheckboxFromCart(freshCart, this);
                    renderRecentlyViewedIfOpen(this);
                    setTimeout(initDragScrolls, 30);
                    return;
                }

                updateCartCountBubble(cart);
                await sectionPromise;
                toggleEmptyState(this, cart);
                syncGiftWrapCheckboxFromCart(cart, this);
                renderRecentlyViewedIfOpen(this);
                setTimeout(initDragScrolls, 30);

                requestAnimationFrame(() => {
                    Urgency.render(this, prevPercent);
                });

                // Update savings from actual Shopify discount data
                const savings = calculateCartSavings(cart);
                const savingsWrap = this.querySelector(SELECTORS.savingsWrap);
                const savingsAmount = this.querySelector(SELECTORS.savingsAmount);
                if (savingsWrap && savingsAmount) {
                    savingsAmount.textContent = savings.toFixed(0);
                    savingsWrap.style.display = savings > 0 ? "block" : "none";
                }

                if (openIfClosed) {
                    this.switchTab("bag");
                    this.open();
                }
                if (this.pendingOpen) { this.pendingOpen = false; this.open(); }

            } catch (err) {
                console.error("[Kymee] drawer refresh error:", err);
            } finally {
                this.setLoading(false);
                this.isRendering = false;
                if (this._pendingRefresh) {
                    const opts = this._pendingRefresh;
                    this._pendingRefresh = null;
                    this.refresh(opts);
                }
            }
        }

        async changeLine(line, quantity) {
            this.setLoading(true);
            try {
                const res = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ line, quantity }),
                });
                const cart = await res.json();
                await this.refresh({ openIfClosed: false, cartData: cart });
            } catch (err) {
                console.error("[Kymee] changeLine error:", err);
                this.setLoading(false);
            }
        }

        onClick(e) {
            // Accordion
            const accordionToggle = e.target.closest("[data-accordion-toggle]");
            if (accordionToggle) {
                const accordion = accordionToggle.closest("[data-accordion]");
                if (accordion) {
                    accordion.classList.toggle("is-open");
                    if (accordion.classList.contains("is-open")) {
                        if (accordion.querySelector("[data-recently-viewed]")) renderRecentlyViewed(this);
                        setTimeout(initDragScrolls, 50);
                    }
                }
                return;
            }

            // Wishlist: Move to Bag
            if (e.target.closest(".kymee-wishlist-move")) {
                const btn = e.target.closest(".kymee-wishlist-move");
                const variantId = btn.dataset.variantId;
                if (!variantId) return;
                btn.textContent = "Adding..."; btn.disabled = true;
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
                })
                    .then((r) => r.json())
                    .then(() => {
                        let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                        list = list.filter((i) => String(i.productVariant) !== String(variantId));
                        localStorage.setItem("wishlist", JSON.stringify(list));
                        document.dispatchEvent(new CustomEvent("wishlist:updated"));
                        this.switchTab("bag");
                        this.refresh({ openIfClosed: false });
                    })
                    .catch(() => { btn.textContent = "Move to Bag"; btn.disabled = false; });
                return;
            }

            // Wishlist: Remove via card button
            if (e.target.closest(".remove_wishlist")) {
                const btn = e.target.closest(".remove_wishlist");
                if (!btn.closest("[data-tab-panel='wishlist']")) return;
                const productId = btn.dataset.productId;
                if (!productId) return;
                e.stopPropagation();
                let list = JSON.parse(localStorage.getItem("wishlist") || "[]");
                list = list.filter((i) => String(i.productId) !== String(productId));
                localStorage.setItem("wishlist", JSON.stringify(list));
                document.dispatchEvent(new CustomEvent("wishlist:updated"));
                renderWishlistTab(this);
                return;
            }

            // Cart item actions
            const row = e.target.closest(SELECTORS.item);
            if (!row) return;
            const line = parseInt(row.dataset.line, 10);

            if (e.target.closest(SELECTORS.remove)) {
                e.preventDefault();
                KymeeRemoveModal.open({ drawer: this, line, row });
                return;
            }

            if (e.target.closest(SELECTORS.qtyMinus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const current = parseInt(input.value, 10);
                if (current === 1) { KymeeRemoveModal.open({ drawer: this, line, row }); return; }
                const val = current - 1;
                input.value = val;
                this.changeLine(line, val);
                return;
            }

            if (e.target.closest(SELECTORS.qtyPlus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const val = parseInt(input.value, 10) + 1;
                input.value = val;
                this.changeLine(line, val);
            }
        }

        async handleGiftWrapChange(checkbox) {
            if (!checkbox) return;
            checkbox.disabled = true;
            try {
                if (checkbox.checked) {
                    await fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: GIFT_WRAP_VARIANT_ID, quantity: 1 }),
                    });
                } else {
                    const cart = await this.fetchCart();
                    const giftItem = cart.items.find((i) => i.variant_id === GIFT_WRAP_VARIANT_ID);
                    if (giftItem) {
                        await fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
                        });
                    }
                }
                await this.refresh({ openIfClosed: false });
            } catch (err) {
                console.error("[Kymee] gift wrap error:", err);
                checkbox.checked = !checkbox.checked;
            } finally {
                checkbox.disabled = false;
            }
        }

        onChange(e) {
            if (e.target.matches("[data-gift-wrap-checkbox]")) {
                this.handleGiftWrapChange(e.target);
                return;
            }
            if (!e.target.matches(SELECTORS.qtyInput)) return;
            const row = e.target.closest(SELECTORS.item);
            if (!row) return;
            const line = parseInt(row.dataset.line, 10);
            const val = Math.max(0, parseInt(e.target.value, 10) || 1);
            e.target.value = val;
            this.changeLine(line, val);
        }
    }

    if (!customElements.get("kymee-cart-drawer")) {
        customElements.define("kymee-cart-drawer", KymeeCartDrawer);
    }

    /* ── Drag-to-scroll ──────────────────────────────────────── */

    function enableDragScroll(el) {
        let isDown = false, startX = 0, scrollStart = 0, hasMoved = false, lastX = 0, velocity = 0, rafId = null;
        el.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            isDown = true; hasMoved = false; startX = e.pageX; lastX = e.pageX;
            scrollStart = el.scrollLeft; velocity = 0;
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
            e.preventDefault();
        });
        document.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            if (Math.abs(e.pageX - startX) > 5) hasMoved = true;
            velocity = e.pageX - lastX; lastX = e.pageX;
            el.scrollLeft = scrollStart - (e.pageX - startX);
        });
        document.addEventListener("mouseup", () => {
            if (!isDown) return;
            isDown = false;
            let vel = -velocity;
            const coast = () => {
                if (Math.abs(vel) < 0.5) return;
                el.scrollLeft += vel; vel *= 0.88;
                rafId = requestAnimationFrame(coast);
            };
            coast();
        });
        el.addEventListener("click", (e) => {
            if (hasMoved) { e.preventDefault(); e.stopImmediatePropagation(); hasMoved = false; }
        }, true);
    }

    function initDragScrolls() {
        document.querySelectorAll(".kymee-wear-with-it_ul, .kymee-rv-list").forEach((el) => {
            if (el.dataset.dragInit) return;
            el.dataset.dragInit = "1";
            enableDragScroll(el);
        });
    }

    initDragScrolls();

    /* ── Urgency event → confetti + GTM ─────────────────────── */

    document.addEventListener("kymee:discount:urgency", (e) => {
        fireCanvasConfetti();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "discount_applied_urgency",
            urgency_step: e.detail.step,
            urgency_percent: e.detail.percent,
        });
    });

    /* ── Wishlist count badge ────────────────────────────────── */

    document.addEventListener("wishlist:updated", () => {
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
            el.textContent = list.length;
            el.style.display = list.length ? "" : "none";
        });
        const drawer = document.querySelector("kymee-cart-drawer");
        const wlPanel = drawer?.querySelector("[data-tab-panel='wishlist']");
        if (wlPanel && !wlPanel.classList.contains("is-hidden")) renderWishlistTab(drawer);
    });

    /* ── Wishlist icon → open drawer ────────────────────────── */

    document.addEventListener("click", (e) => {
        const wlLink = e.target.closest('a[href="/pages/custom-wishlist"], .wishlist-icon');
        if (!wlLink) return;
        e.preventDefault();
        const drawer = document.querySelector("kymee-cart-drawer");
        if (!drawer) return;
        drawer.open();
        drawer.switchTab("wishlist");
    });

    /* ── Init wishlist count badge on page load ─────────────── */
    (function () {
        const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
        document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
            el.textContent = list.length;
            el.style.display = list.length ? "" : "none";
        });
    })();

    /* ── Dawn cartUpdate binding ────────────────────────────── */

    (function bindKymeeCartUpdate(retry = 0) {
        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                const cart = event.cartData;
                if (!cart || typeof cart.item_count !== "number") return;
                updateCartCountBubble(cart);
                const drawer = document.querySelector("kymee-cart-drawer");
                if (drawer?.isOpen) {
                    drawer.refresh({ openIfClosed: false });
                }
            });
        } else if (retry < 10) {
            setTimeout(() => bindKymeeCartUpdate(retry + 1), 50);
        }
    })();

})();
